import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const AiAdDialog = ({ open, onClose }) => {
  const handleClose = () => {
    localStorage.setItem("showAiAdDialog", "false");
    onClose();
  };

  const handleExplore = () => {
    window.open("https://thisis.my-board.org/", "_blank");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AutoAwesomeIcon color="primary" />
          <Typography variant="h6" component="div" color="primary">
            Talent-to-Role Analyzer AI
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom color="primary" fontWeight="bold">
          Compare Candidates to Jobs Instantly!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Use AI to match resumes with job descriptions for quick, accurate
          results and insights.
        </Typography>

        <Box
          sx={{
            backgroundColor: "#f0f0f0",
            borderRadius: "8px",
            p: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="subtitle1"
            color="textPrimary"
            fontWeight="bold"
            gutterBottom
          >
            Why Choose Our AI Analyzer?
          </Typography>
          <Typography variant="body2" color="textSecondary" component="div">
            <ul style={{ margin: 0, paddingLeft: "20px" }}>
              <li>
                ⚡ <strong>Lightning Fast:</strong> Get results in seconds, not
                hours
              </li>
              <li>
                🎯 <strong>Highly Accurate:</strong> Advanced algorithms for
                precise matching
              </li>
              <li>
                📊 <strong>Detailed Reports:</strong> Comprehensive analysis
                with actionable insights
              </li>
              <li>
                🎓 <strong>Student-Friendly:</strong> Perfect for academic
                projects and career services
              </li>
            </ul>
          </Typography>
        </Box>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: "italic" }}
        >
          Join thousands using AI for smarter hiring. Start free today!
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={handleClose} variant="outlined" color="primary">
          Maybe Later
        </Button>
        <Button onClick={handleExplore} variant="contained" color="primary">
          Explore Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiAdDialog;
